import { render, staticRenderFns } from "./TelegramAiSettings.vue?vue&type=template&id=1849a3fb"
import script from "./TelegramAiSettings.vue?vue&type=script&lang=js"
export * from "./TelegramAiSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports